import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './terminationReasons.intl.json';

export const useTerminationReasonsIntl = () => useIntlModule(messages);
